import { route, type DemoRoute } from '../router';
import {
  getAccAssignments,
  getAnalyticParts,
  getDealNames,
  getUnitsOfMeasure,
} from '../data/erp';

// ERP reference-data dropdowns consumed by the SaldoReview line-item ERP rows.
// action_type: 103 = purchases (default), 102 = sales.
function actionType(query: URLSearchParams): number {
  const raw = Number(query.get('action_type'));
  return raw === 102 ? 102 : 103;
}

export const erpHandlers: DemoRoute[] = [
  route('GET', '/clients/:clientId/deal-names', ({ query }) => ({
    deal_names: getDealNames(actionType(query)),
  })),

  route('GET', '/clients/:clientId/acc-assignment', ({ query }) => ({
    acc_assignments: getAccAssignments(actionType(query)),
  })),

  route('GET', '/clients/:clientId/acc-assignment/:accAssignmentId/analytic-parts', ({ params }) => ({
    acc_assignment_id: Number(params.accAssignmentId),
    taken_position: null,
    analytic_parts: getAnalyticParts(Number(params.accAssignmentId)),
  })),

  route('GET', '/clients/:clientId/units-of-measure', () => ({
    units_of_measure: getUnitsOfMeasure(),
  })),
];
